import RecentActorsIcon from "@mui/icons-material/RecentActors";
import { IRoute } from "../../common/typings/routes";
import { CompanyProfileModule } from "./companyProfileModule";
import { CompanyProfile } from "./pages/CPDetails";
import { PaymentRemittancePage } from "./pages/PaymentRemittance/PaymentRemittancePage";

export const CompanyProfileRoute: IRoute = {
  title: "Company Profile",
  path: "/company-profile",
  icon: RecentActorsIcon,
  component: CompanyProfileModule,
  guard: true,
  subRoutes: [
    {
      component: CompanyProfile,
      path: "/details",
      title: "Company Profile",
    },
    {
      component: PaymentRemittancePage,
      path: "/payment-remittance",
      title: "Payment Remittance",
    },
  ],
};
